import type { CustomTheme } from '../../@types/theme';
import { THEME } from '../EditorContentTypes';
import { darkTheme, lightTheme } from '../theme';

type GetDesignLibraryProps = {
  unifiedWebCommonVersion?: string;
  unifiedWebAlphaCommonVersion?: string;
};

export const getDesignLibrary = (props?: GetDesignLibraryProps): { [key: string]: string } => {
  if (process.env.IS_LEGACY) {
    return {
      '@oneaudi/unified-web-common': props?.unifiedWebCommonVersion || '*',
    };
  }
  return {
    '@oneaudi/unified-web-alpha-common': props?.unifiedWebAlphaCommonVersion || '*',
  };
};

export const getThemeName = (theme: THEME): CustomTheme => {
  if (process.env.IS_LEGACY) {
    return theme === THEME.LIGHT ? lightTheme : darkTheme;
  }
  return darkTheme;
};
